module.exports = __webpack_public_path__ + "img/horizontal_7_6_8017.56e0078d.png";